import React from 'react';
export function Footer() {
  return <footer className="w-full max-w-4xl mx-auto mt-16 mb-8 text-center space-y-6" data-id="element-84">
      <div className="bg-black text-[#00ff00] inline-block p-4 border-4 border-gray-600 font-mono text-xl" data-id="element-85">
        You are visitor #<span className="text-red-500 font-bold" data-id="element-86">48,293</span>!
      </div>

      <div className="bg-[#ffb6c1] border-2 border-[#ff1493] p-4 text-sm text-[#8b008b] space-y-2" data-id="element-87">
        <p className="font-bold" data-id="element-88">DISCLAIMER:</p>
        <p data-id="element-89">
          This page is NOT affiliated with Cedrine Dion, her management, or her
          record label.
        </p>
        <p data-id="element-90">
          All images belong to their respective owners. No copyright
          infringement intended!!!
        </p>
        <p data-id="element-91">Made with 💖 by CedrineLuvr4eva</p>
      </div>

      <div className="flex justify-center gap-4 flex-wrap" data-id="element-92">
        <div className="bg-blue-800 text-white text-xs p-1 border border-white w-24 text-center" data-id="element-93">
          Best viewed in
          <br data-id="element-94" />
          Internet Explorer 6.0
        </div>
        <div className="bg-black text-yellow-400 text-xs p-1 border border-gray-500 w-24 text-center" data-id="element-95">
          800x600
          <br data-id="element-96" />
          Resolution
        </div>
        <div className="bg-red-600 text-white text-xs p-1 border border-black w-24 text-center font-bold" data-id="element-97">
          Powered by
          <br data-id="element-98" />
          Angelfire
        </div>
      </div>

      <div className="text-[#ff1493] font-bold" data-id="element-99">
        <p data-id="element-100">Last updated: March 13, 2003</p>
        <a href="#" className="underline hover:text-blue-600 block mt-2" data-id="element-101">
          [ Sign my guestbook!!! ]
        </a>
        <a href="mailto:cedrineluvr4eva@hotmail.com" className="underline hover:text-blue-600 block mt-2" data-id="element-102">
          Email me: cedrineluvr4eva@hotmail.com
        </a>
      </div>
    </footer>;
}